import { Slide, ToastOptions } from 'react-toastify'

export const defaultToastOptions: ToastOptions = {
  position: 'top-center',
  hideProgressBar: false,
  closeOnClick: true,
  closeButton: false,
  pauseOnHover: true,
  draggable: true,
  draggableDirection: 'x',
  theme: 'colored',
  transition: Slide,
  autoClose: 4000,
}
